export default defineNuxtRouteMiddleware(async (to) => {
  // 使用 Nuxt i18n 內建的 detectBrowserLanguage 功能
  // 只處理特定頁面的語言邏輯
  if (import.meta.server) return

  const nuxtApp = useNuxtApp()
  await nextTick()

  try {
    const $i18n = nuxtApp.$i18n
    if (!$i18n || typeof $i18n.setLocale !== 'function') {
      return
    }

    if (to.path === '/chat') {
      // /chat 頁面：根據瀏覽器語言設定
      // 支援的語言配置（與 nuxt.config.ts 保持一致）
      const supportedLocales = [
        {
          code: 'en' as const,
          language: 'en-US',
          variants: ['en', 'en-US', 'en-GB', 'en-AU']  // 英文變體
        },
        {
          code: 'zh-TW' as const,
          language: 'zh-TW',
          variants: ['zh-TW', 'zh-Hant', 'zh-Hant-TW', 'zh-HK', 'zh-Hant-HK', 'zh-MO']  // 繁體中文變體
        }
      ]

      const browserLanguages = navigator.languages || [navigator.language]

      // 找出最匹配的語言
      let targetLocale: 'en' | 'zh-TW' = 'en' // 預設語言

      for (const browserLang of browserLanguages) {
        const normalizedBrowserLang = browserLang.toLowerCase()

        // 1. 檢查完全匹配（最優先）
        const exactMatch = supportedLocales.find(
          locale => locale.language.toLowerCase() === normalizedBrowserLang
        )

        if (exactMatch) {
          targetLocale = exactMatch.code
          break
        }

        // 2. 檢查變體匹配
        const variantMatch = supportedLocales.find(
          locale => locale.variants.some(v => v.toLowerCase() === normalizedBrowserLang)
        )

        if (variantMatch) {
          targetLocale = variantMatch.code
          break
        }

        // 3. 檢查主語言匹配（例如 zh-TW 匹配 zh）
        const mainLang = normalizedBrowserLang.split('-')[0]
        const mainLangMatch = supportedLocales.find(
          locale => locale.language.toLowerCase().split('-')[0] === mainLang
        )

        if (mainLangMatch) {
          targetLocale = mainLangMatch.code
          break
        }
      }

      // 如果瀏覽器語言與當前語言不同，切換語言
      if ($i18n.locale.value !== targetLocale) {
        await $i18n.setLocale(targetLocale)
        // 同時更新 cookie，確保下次 SSR 渲染正確的語言
        $i18n.setLocaleCookie(targetLocale)
      }
    } else {
      // 非 /chat 頁面：強制設為英文
      if ($i18n.locale.value !== 'en') {
        await $i18n.setLocale('en')
      }
    }
  } catch (error) {
    console.warn('Language management error:', error)
  }
})